module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_4-df8425abef5b591659a252989a90a807.png";